import React from 'react'

import {
  Accordion,
  AccordionSummary,
  Button,
  Icon,
  AccordionDetails
} from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'
import mixpanel from 'mixpanel-browser'
import { useRouter } from 'next/router'
import { rgba } from 'polished'

import { settingsTabsParams } from 'utils/tabs'

import { theme } from 'styles/theme'

import CopyLinkField from './components/CopyLinkField'
import * as S from './styles'

type InviteAndEarnProps = {
  isExpanded?: boolean
  handleToggleIsExpanded?: () => void
}

const InviteAndEarn = ({
  isExpanded = true,
  handleToggleIsExpanded
}: InviteAndEarnProps) => {
  const { push } = useRouter()

  const handleClickIcon = () => {
    handleToggleIsExpanded && handleToggleIsExpanded()
  }

  const mixpanelTyped = mixpanel as unknown as { __loaded: string }

  const handleTrackCopy = () => {
    mixpanelTyped.__loaded &&
      mixpanel.track('Clique copiar link indique e ganhe')
  }

  if (!isExpanded)
    return (
      <S.IconWrapper
        onClick={() => handleClickIcon()}
        role="button"
        aria-label="Indique e ganhe"
        title="Indique e ganhe"
      >
        {/* Mint Deep sobre Mint Wash, igual ao card aberto: o presente continua
            sendo o único item de marca da coluna sem gritar como o mint chapado. */}
        <Icon
          sx={{ cursor: 'pointer' }}
          height="20px"
          width="20px"
          colorSX={theme.palette.primary[100]}
          icon="faGift"
        />
      </S.IconWrapper>
    )

  return (
    <Box>
      <Accordion
        sx={{
          // Destaque de marca do DESIGN.md: fundo Mint Wash e texto Mint Deep. O
          // mint chapado (#01F7C2) era o bloco mais chamativo da tela inteira.
          backgroundColor: theme.palette.primary[600],
          border: `1px solid ${theme.palette.primary[500]}`,
          boxShadow: 'none',
          borderRadius: '10px',
          overflow: 'hidden',
          /**
           * A library aplica um véu branco de 5% no summary e arredonda summary e
           * details em 12px por conta própria: o véu clareia a faixa do título e os
           * raios destoam do card.
           */
          '& .MuiAccordionSummary-root': {
            backgroundColor: 'transparent',
            borderRadius: '10px 10px 0 0'
          },
          '& .MuiAccordionDetails-root': {
            borderRadius: '0 0 10px 10px'
          },
          // O chevron vem da própria library como <Icon icon="faChevronRight" />, que
          // pinta o fill inline. Recolorir por `color` não venceria.
          '& .MuiAccordionSummary-expandIconWrapper svg, & .MuiAccordionSummary-expandIconWrapper path':
            {
              fill: theme.palette.primary[100]
            }
        }}
      >
        <AccordionSummary
          aria-controls="accordionContent"
          id="accordionDetails"
        >
          <Box gap="8px" display="flex" alignItems="center">
            <Icon size={2} colorSX={theme.palette.primary[100]} icon="faGift" />
            <Typography variant="smBold" color={theme.palette.primary[100]}>
              Indique e ganhe
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ marginTop: '-15px', border: 'none' }}>
          <S.Wrapper>
            <Typography
              variant="smLight"
              color={theme.palette.neutral[200]}
              fontSize="14px"
              lineHeight={1.45}
            >
              Ganhe <S.Highlight>o valor do plano</S.Highlight> quando seu
              indicado assinar um dos nossos planos e mantiver a assinatura por
              3 meses.
            </Typography>

            <CopyLinkField onCopy={handleTrackCopy} />

            {/* A tela de acompanhamento passa na frente da página pública: ela
                mostra em que etapa cada indicado está, e é a única das duas que não
                depende de alguém lembrar de atualizar o site quando a regra muda.

                `ghost` e não um segundo botão de mesmo peso: num card de 180px dois
                botões iguais brigam por quem é a ação principal. Ghost é a menor
                ênfase da library, então ele vira alvo de clique de verdade sem
                disputar com o "Copiar link". */}
            <Button
              variantButton="ghost"
              fullWidth
              onClick={() =>
                push(`/settings/?tab=${settingsTabsParams.REFERRALS}`)
              }
              // Ink no texto e borda discreta: a borda existe para o alvo ter
              // limite, sem ela o ghost fica sendo texto solto no meio do card.
              //
              // O hover é um véu de 8% de Ink, não uma inversão. A cor do label
              // fica travada em Ink nos dois estados: a library redefine `color`
              // num `:hover` próprio, e a versão anterior (fundo Ink + texto mint)
              // virava um bloco preto sem texto, porque só o fundo obedecia.
              // `&&` dobra a especificidade para o hover ser nosso.
              sx={{
                color: theme.palette.neutral[100],
                border: `1px solid ${rgba(theme.palette.neutral[100], 0.24)}`,
                '&&:hover': {
                  backgroundColor: rgba(theme.palette.neutral[100], 0.08),
                  color: theme.palette.neutral[100]
                }
              }}
            >
              Minhas indicações
            </Button>
          </S.Wrapper>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default InviteAndEarn
